const MODULE_NAME = "BARRIER/";

export const PAGINATION = {
  log: {
    page: 1,
    size: 10
  },
  camera: {
    page: 1,
    size: 20
  },
  gate: {
    page: 1,
    size: 20
  }
};

export const BROWSE_LOG_BARRIER = `${MODULE_NAME}/LOGS`;
